import { Host, h } from "@stencil/core";
export class ChNotificationsItem {
    constructor() {
        this.timerInterval = 50;
        this.closeButtonAccessibleName = "Close";
        this.dismissTimeout = 0;
        this.leftImgSrc = "";
        this.showCloseButton = false;
        this.showTimeoutBar = false;
        this.pauseOnHover = true;
        this.countdown = this.dismissTimeout;
    }
    /**
     * Used to not fire an extra event when the control is dismissed before the
     * dismiss timeout is called.
     */
    timerId;
    element;
    timeoutWatcher(newValue) {
        if (newValue) {
            this.countdown = newValue;
            this.start();
        }
    }
    /** Countdown watcher that hides the alert if dismissTimeout is reached
     * and stops the countdown.
     * See handleNotificationDismiss for more details. */
    countdownWatcher(newValue) {
        if (newValue <= 0) {
            this.handleNotificationDismiss();
        }
    }
    /** the notificationClick event */
    notificationClick;
    /** the notificationDismiss event */
    notificationDismiss;
    /** Closes the alert when the close button is clicked.
     * Also restarts the counter and sets its value to match dismissTimeout.
     */
    handleNotificationDismiss = () => {
        clearInterval(this.timerId);
        this.notificationDismiss.emit(Number(this.element.id));
    };
    /** Handles the notification click */
    handleNotificationClick = () => {
        clearInterval(this.timerId);
        this.notificationClick.emit(Number(this.element.id));
    };
    /** Counter decremental function */
    counter = () => {
        this.countdown -= this.timerInterval;
    };
    /** Starts a new countdown which interval is set in timerInterval,
     * Only if is presented, dismissTimeout is greater than 0,
     * and countdown is still running.
     */
    start = () => {
        clearInterval(this.timerId);
        if (this.dismissTimeout !== 0 && this.countdown >= 0) {
            this.timerId = setInterval(this.counter, this.timerInterval);
        }
    };
    /** Pauses the countdown */
    handleMouseEnter = () => {
        clearInterval(this.timerId);
    };
    /** Resumes the countdown */
    handleMouseLeave = () => {
        this.start();
    };
    componentDidLoad() {
        this.start();
    }
    render() {
        return (h(Host, { key: '05701b0c928afaa7eb59263b1fe67be440f22471', onMouseEnter: this.pauseOnHover && this.handleMouseEnter, onMouseLeave: this.pauseOnHover && this.handleMouseLeave, "aria-hidden": "false", class: this.pauseOnHover && "pause-on-hover", onClick: this.handleNotificationClick }, this.leftImgSrc && (h("img", { key: '5b24bd1b2c374c98f4e04091ed42819913ef1be6', part: "image", class: "image", src: this.leftImgSrc, alt: "", "aria-hidden": "true", loading: "lazy" })), h("div", { key: '72029e965a5ac4a8d4623f6683e659b17c865988', part: "content", class: "content" }, h("slot", { key: '579801d143a696e580ac326c124961b9bc567624', name: "content" })), this.showCloseButton && (h("button", { key: '7e85e0308539356ae4264464ae1c1961d4113d25', part: "close-button", class: "close-button", type: "button", "aria-label": this.closeButtonAccessibleName, onClick: this.handleNotificationDismiss }, h("slot", { key: '836e27878fb2ae0d7d3c79f46770937c0c06ad80', name: "button", "aria-hidden": "true" }, h("div", { key: 'bcdf1cc37edf2af2c8addd8ab54df177e63957e9', "aria-hidden": "true", class: "close-button-img" })))), this.showTimeoutBar && (h("ch-timer", { key: 'b07b317713d914bd73588e5fe9f0cdee501266b5', part: "indicator-container", class: "indicator-container", exportparts: "indicator", progress: (this.countdown * 100) / this.dismissTimeout, accessibleName: `${this.countdown / 1000} seconds left`, "animation-time": this.dismissTimeout, presented: true }))));
    }
    static get is() { return "ch-notifications-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["notifications-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["notifications-item.css"]
        };
    }
    static get properties() {
        return {
            "timerInterval": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "50",
                    "resolved": "50",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Sets the desired interval"
                },
                "attribute": "timer-interval",
                "reflect": false,
                "defaultValue": "50"
            },
            "closeButtonAccessibleName": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determine the accessible name of the close button.\nImportant for accessibility."
                },
                "attribute": "close-button-accessible-name",
                "reflect": false,
                "defaultValue": "\"Close\""
            },
            "dismissTimeout": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "0",
                    "resolved": "0",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the time (ms) for the alert to be displayed.\nif `dismissTimeout = 0`, the alert will be always visible\n(unless is dismissed by the closeButton)."
                },
                "attribute": "dismiss-timeout",
                "reflect": false,
                "defaultValue": "0"
            },
            "leftImgSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"\"",
                    "resolved": "\"\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determine src of the left image."
                },
                "attribute": "left-img-src",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "showCloseButton": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determine if the closeButton is displayed or not."
                },
                "attribute": "show-close-button",
                "reflect": false,
                "defaultValue": "false"
            },
            "showTimeoutBar": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If dismissTimeout > 0, a progress bar is displayed at the bottom of the element\nshowing the time left for the alert to show.\nThe progress stops when the element is hovered."
                },
                "attribute": "show-timeout-bar",
                "reflect": false,
                "defaultValue": "false"
            },
            "pauseOnHover": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Toggles the Pause on Hover functionality"
                },
                "attribute": "pause-on-hover",
                "reflect": false,
                "defaultValue": "true"
            },
            "countdown": {
                "type": "number",
                "mutable": true,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Countdown which initial state is dismissTimeout ms."
                },
                "attribute": "countdown",
                "reflect": false,
                "defaultValue": "this.dismissTimeout"
            }
        };
    }
    static get events() {
        return [{
                "method": "notificationClick",
                "name": "notificationClick",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "the notificationClick event"
                },
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                }
            }, {
                "method": "notificationDismiss",
                "name": "notificationDismiss",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "the notificationDismiss event"
                },
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "element"; }
    static get watchers() {
        return [{
                "propName": "dismissTimeout",
                "methodName": "timeoutWatcher"
            }, {
                "propName": "countdown",
                "methodName": "countdownWatcher"
            }];
    }
}
